import { render, staticRenderFns } from "./KhachHangListAddNew.vue?vue&type=template&id=31a14092&"
import script from "./KhachHangListAddNew.vue?vue&type=script&lang=js&"
export * from "./KhachHangListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./KhachHangListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports